/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Child_Age_PlaceholderInputs */

const en_guest_picker_child_age_placeholder = /** @type {(inputs: Guest_Picker_Child_Age_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select age`)
};

/**
* | output |
* | --- |
* | "Select age" |
*
* @param {Guest_Picker_Child_Age_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_child_age_placeholder = /** @type {((inputs?: Guest_Picker_Child_Age_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Child_Age_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_child_age_placeholder(inputs)
});